import Model from 'scomponent/src/data/model'
import fieldTranslation from '../../../.env.models.json'

export class CategoryModel extends Model {
  private static instance: CategoryModel = new CategoryModel()
  id: number = 0
  name: string = ''
  description: string = ''
  parentId: number = 0
  photos: any = []
  children: any = []

  public static getInstance(): CategoryModel {
    this.instance.setTranslateField(fieldTranslation['Category'])
    return CategoryModel.instance
  }

  getName() {
    return this.name
  }

  getDescription() {
    return this.description
  }

  getPhotos() {
    return this.photos
  }

  getChildren() {
    return this.children
  }
}
